import React,{ useState,useEffect } from "react"
import Switch from '@material-ui/core/Switch';
import Hidden from '@material-ui/core/Hidden';

const Animationbtns = {

   position: "relative",
    margin:" 30px 0px 14px"

}

const animTitle = {
   display: 'inline-block',
    verticalAlign: 'middle',
    width: '57%',
    textAlign: 'right',
    paddingLeft: '15px',
    paddingRight: '10px'
}
const AnimationbtnsMob = {
   textAlign: "center",marginTop: "25px",position: "relative",marginBottom: "14px"

}

const AnimationBtn = (props) => {



   return (
      <>

         <div id="animation" style={Animationbtns}>
            <span style={animTitle}> {window.finalLangues.reduceTransitions}: </span>
            {/* <Switch id="switchValue" onChange={displayName} name="checkedA" color="primary"/><span className = 'onOff'>{value}</span> */}
            <label className="switch" tabIndex="1" id="animswtich" onKeyPress={props.forKeypress} >
               <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" onChange={props.onchange} type="checkbox" />
               <span className="tabIndexStyle slider round" ></span>
               <span className="onOff"></span>
            </label>
         </div>
         {!(window.mob) &&
            <div id="animation1" style={{ position:'relative' }}>
               <span style={animTitle}> {window.finalLangues.onScreenControls}: </span>
               {/* <Switch id="switchValue" onChange={displayName} name="checkedA" color="primary" /><span className='onOff'>{value}</span> */}
               <label className="switch" tabIndex="1" id="animswtich1" onKeyPress={props.forKeypress1} >
                  <input tabIndex="-1" className="tabIndexStyle" name='keyboadrControlsOnOff' id="animSwitchValue1" onChange={props.onchange1} type="checkbox" />
                  <span className="tabIndexStyle slider round"></span>
                  <span className="onOff1"></span>
               </label>
            </div>
         }
      </>
   )
}

export default AnimationBtn;